import CrossIcon from '@atlaskit/icon/glyph/cross';
import { Appearance } from '@atlaskit/section-message';
import classNames from 'classnames';
import React, { Component } from 'react';
import { InfoPanel } from '../../info-panel';

export interface Props {
  id: string;
  message: string;
  onCloseClick: (id: string) => void;
  header: string;
  isCloseable: boolean;
  detailList?: (() => JSX.Element)[];
  type?: Appearance;
}

class Notification extends Component<Props> {
  onCloseClick = () => {
    const { onCloseClick, id } = this.props;
    onCloseClick(id);
  };

  render() {
    const { message, header, type, detailList, isCloseable } = this.props;
    const className = classNames('notification', {
      closeable: isCloseable,
    });
    const closeButton = isCloseable ? (
      <span
        className="close-button"
        data-testid="notification-close-button-test-id"
        onClick={this.onCloseClick}
        role="button"
        tabIndex={0}
      >
        <CrossIcon size="small" label="Close Notification" />
      </span>
    ) : null;

    return (
      <div className={className} data-testid="notification-test-id">
        <InfoPanel title={header} type={type ? type : 'success'} message={message} detailList={detailList}></InfoPanel>
        {closeButton}
      </div>
    );
  }
}

export default Notification;
